/* eslint-disable import/prefer-default-export */
export enum Roles {
  ROOT = 'ROOT',
  ADMIN = 'ADMIN',
  USER = 'USER',
  EDITOR = 'EDITOR',
}
